(function() { window.GUID_0fa2b81d_7006_4234_8096_0dab15584453 = { getGuid: function() { return "0fa2b81d-7006-4234-8096-0dab15584453"; } }; })();
var CS;
(function (CS) {
    function trigger(type, fn) {
        return CS.body.trigger(type, fn);
    }
    CS.trigger = trigger;
    function on(type, selectorOrFn, fn) {
        if (typeof fn != "undefined") {
            return CS.body.on(type, selectorOrFn, fn);
        }
        else {
            return CS.body.on(type, selectorOrFn);
        }
    }
    CS.on = on;
    function off(event, selector, handler) {
        return CS.body.off(event, selector, handler);
    }
    CS.off = off;
    function FormReady(delegate) {
        CompuSport.Controls.FormReadyArray.push(delegate);
        //formReadyArray.push(delegate);
    }
    CS.FormReady = FormReady;
    class Position {
        constructor(left, top) {
            this.Left = left;
            this.Top = top;
            this.Right = 0;
            this.Bottom = 0;
        }
    }
    CS.Position = Position;
    class Size {
        constructor(width, height) {
            this.Width = width;
            this.Height = height;
        }
    }
    CS.Size = Size;
    CS.body = $("body");
    CS.navLoadingIndicator = $("#NavLoadingIndicator");
    CS.masterBody = $("#MasterBody");
    CS.doc = $(document);
    CS.win = $(window);
    CS.docHtml = $("html");
    CS.formReadyArray = [];
    let antiforgeryToken = $("input[name=__RequestVerificationToken]");
    function GetHiddenAntiforgertyToken() {
        //Important que ce soit un clone, sinon, il le remove de lautre endroit lorsque c'Est une popup et que celle ci se referme
        return antiforgeryToken.clone();
    }
    CS.GetHiddenAntiforgertyToken = GetHiddenAntiforgertyToken;
    function CSRess(params) {
        var _a;
        const { french, english, spanish } = params;
        const lang = (_a = CSParameters === null || CSParameters === void 0 ? void 0 : CSParameters.Language) !== null && _a !== void 0 ? _a : "en";
        switch (lang) {
            case "fr":
                return french;
            case "es":
                return spanish;
            //case "fi":
            //    return finish;
            case "en":
            default:
                return english;
        }
    }
    CS.CSRess = CSRess;
    let clickCount = 0;
    CS.body.on("click", ".CSValidationSummaryErrors", function (e) {
        var $target = $(e.target);
        if ($target.hasClass("CSValidationSummaryErrorsCloseButton")) {
            $(this).slideUp();
        }
    });
    CS.win.on("beforeunload", function (e) {
        console.log("beforeunload");
        CS.navLoadingIndicator.show();
        CompuSport.DOM.Navigating = true;
        setTimeout(function () {
            CS.navLoadingIndicator.hide();
            CompuSport.DOM.Navigating = false;
        }, 7000);
    });
    CS.win.on("downloadfinished", function () {
        console.log("downloadfinished");
        setTimeout(function () {
            CS.navLoadingIndicator.hide();
            CompuSport.DOM.Navigating = false;
        }, 1000);
    });
    CS.navLoadingIndicator.show();
    CompuSport.on("allscriptsloaded", function () {
        $(".CSToolButton").on("keydown", function (e) {
            e.preventDefault();
        });
        $.ajaxSettings.traditional = true;
        CS.RefreshBehaviorOfScript(document);
        var busyIndicator = $("#BusyIndicator");
        if ($("#BusyIndicator") != null) {
            CS.doc
                .ajaxStart(function () {
                //Si on veut pas que ca soit caller le ajaxStart, on doit setter global = false dans le call .ajax en question.
                $("#BusyIndicator").show();
            })
                .ajaxStop(function () {
                $("#BusyIndicator").hide();
            })
                .ajaxError(function (xhr, see, err) {
                if (see.statusText == "abort" || CompuSport.DOM.Navigating) {
                    return;
                }
                let errorAlreadyVisible = $("#CSError").is(":visible");
                if (see.responseText != undefined &&
                    see.responseText != "" &&
                    !errorAlreadyVisible) {
                    $("#CSErrorCloseBtn").off("click");
                    $("#CSErrorCloseBtn").on("click", function () {
                        $("#CSError").hide();
                    });
                    var csErrorMessage = $("#CSErrorMessage");
                    csErrorMessage.html(see.responseText);
                    var isAccesDenied = $(".AccesDenied", csErrorMessage);
                    if (isAccesDenied.length > 0) {
                        window.location.replace(CSParameters.RUrl +
                            "Account/Login/" +
                            CSParameters.SportEventId +
                            "?returnUrl=" + CSParameters.ReturnUrlEncoded);
                        return;
                        //$('#LoginWhenAccesDenied').show();
                    }
                    $("#CSError").show();
                }
            });
        }
        CS.navLoadingIndicator.hide();
        $("#ComboLanguage").on("change", function (e) {
            window.location.assign(decodeURIComponent($(this).val()));
        });
    });
    if (!(typeof CSParameters === "undefined")) {
        //Ici, je m'assure que toutes requêtes ajax contient le sport event id
        $.ajaxSetup({
            data: {
                SportEventId: CSParameters.SportEventId,
                CSToken: $("#CSToken").val(),
                RequestVerificationToken: CS.GetHiddenAntiforgertyToken().val() /*Necessaire pour les call ajax direct qui ne sont pas des popups*/,
            },
            cache: false,
            beforeSend: function (xhr) {
                xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            },
        });
    }
    function RefreshBehaviorOfScript(contextElement) {
        var ele = $(":input[data-isfocus]", contextElement).first();
        ele.focus();
        ele.select();
        $(".CSAccordion", contextElement).accordion({
            heightStyle: "content",
        });
        $(".CSColorPicker", contextElement).CSColorPicker();
        $(":input[data-autocompleteurl]", contextElement).CSAutoComplete();
        $("input[type=text], input[type=email], textarea", contextElement).CSTextBox();
        $("input:checkbox", contextElement).CSCheckBox();
        $("input:radio", contextElement).CSRadio();
        $("input[data-watermark]", contextElement).CSWaterMark();
        $(".CSInputNum", contextElement).each(function () {
            $(this).ForceNumericOnly();
        });
        $(".CSDropDown", contextElement).CSDropDown();
        $(".CSDatePicker", contextElement).CSDatePicker();
        $(".CSCalendarPicker", contextElement).CSCalendarPicker();
        $(".CSTimePicker", contextElement).CSTimePicker();
        $(".CSGridView", contextElement).CSGridView();
        //Ici, j'évite que la touche tab selectionne un anchor qui a la class IsDisabled
        var disableItems = $(".IsDisabled a");
        disableItems.attr("tabindex", "-1");
        if (contextElement != null &&
            contextElement.length != null &&
            contextElement.length > 0 &&
            contextElement[0].tagName == "FORM") {
            if (CompuSport.Controls.FormReadyArray != null &&
                CompuSport.Controls.FormReadyArray.length > 0) {
                $.each(CompuSport.Controls.FormReadyArray, function (index, delegate) {
                    delegate.call(contextElement, contextElement[0].id);
                });
            }
        }
        var csValidationSummaryErrors = $(".CSValidationSummaryErrors");
        if (csValidationSummaryErrors.length > 0) {
            var parentForm = csValidationSummaryErrors.closest(".ui-dialog");
            if (parentForm.length > 0) {
                csValidationSummaryErrors.css("left", parentForm.offset().left + "px");
            }
            csValidationSummaryErrors.draggable();
            HighlightErrorsParentAccordion(contextElement);
        }
    }
    CS.RefreshBehaviorOfScript = RefreshBehaviorOfScript;
    function LogAction(url, tags) {
        var logUrl = CSParameters.BaseUrl +
            "Global/LogUserAction/" +
            CSParameters.SportEventId;
        var data = {};
        data.url = url;
        data.tags = tags;
        CompuSport.Ajax.Post(logUrl, data);
    }
    CS.LogAction = LogAction;
    function HighlightErrorsParentAccordion(formDialog) {
        var errorsElements = $(".ErrorMessage", formDialog);
        var parentAccordions = errorsElements.closest(".ui-accordion-content");
        $.each(parentAccordions, function () {
            var correspondingHeader = formDialog.find("[aria-controls =" + this.id + "]");
            correspondingHeader.addClass("AccordionError");
        });
    }
    function PrepareDataToSendGlobal(me) {
        var dynamicItem = {};
        if (me.RefreshElementIds != null && me.RefreshElementIds[0] != "") {
            $.each(me.RefreshElementIds, function (index, id) {
                AppendPropertiesToDynamicItem(id, dynamicItem);
            });
        }
        if (me.BindElementIds != null && me.BindElementIds[0] != "") {
            $.each(me.BindElementIds, function (index, id) {
                AppendPropertiesToDynamicItem(id, dynamicItem);
            });
        }
        return dynamicItem;
    }
    CS.PrepareDataToSendGlobal = PrepareDataToSendGlobal;
    function AppendPropertiesToDynamicItem(identifier, item) {
        var element = $("#" + identifier);
        var context = element.data("context");
        //Permet de fonctionner avec les radio buttons grace à ca puisque
        //le radio button n'a pas de Id
        if (element.length == 0) {
            element = $('[name="' + identifier + '"]:checked');
        }
        if (element.length > 0) {
            if (context != undefined && context.PrepareDataToSend != undefined) {
                context.PrepareDataToSend(item);
            }
            else if (element[0].type == "checkbox") {
                let value = element[0].checked;
                item[identifier] = value;
            }
            else {
                let value = element.val();
                item[identifier] = value;
            }
        }
    }
    function ManageClickCount(e, callback) {
        var mouseButton = "";
        switch (e.which) {
            case 1:
                mouseButton = "left";
                break;
            case 2:
                mouseButton = "middle";
                break;
            case 3:
                mouseButton = "right";
                break;
            default:
                mouseButton = "left";
                break;
        }
        if (clickCount == 0) {
            setTimeout(function () {
                callback.call(this, mouseButton, clickCount);
                clickCount = 0;
            }, 350);
        }
        clickCount += 1;
    }
    CS.ManageClickCount = ManageClickCount;
    function AutoSetScaleClass(element) {
        element
            .removeClass("ScaleFullWidth")
            .removeClass("ScaleFullHeight")
            .removeClass("NotShowNow");
        var autoScale = element.parent().data("autoscale");
        var parent = element.parent();
        var parentRatio = parent.width() / parent.height();
        var elementWidth = element.width();
        var elementHeight = element.height();
        var parentWidth = parent.width();
        var parentHeight = parent.height();
        var classToUse = "";
        var ratioX = parentWidth / elementWidth;
        var ratioY = parentHeight / elementHeight;
        var ready = true;
        if (elementWidth == 0) {
            ready = false;
            classToUse = "NotShowNow";
        }
        else {
            if (autoScale == "None" || autoScale == "ScaleFit") {
                if (ratioX > ratioY) {
                    classToUse = "ScaleFullHeight";
                }
                else {
                    classToUse = "ScaleFullWidth";
                }
            }
            else if (autoScale == "FullHeight") {
                classToUse = "ScaleFullHeight";
            }
            else if (autoScale == "FullWidth") {
                classToUse = "ScaleFullWidth";
            }
            else if (autoScale == "ScaleFill") {
                if (ratioX < ratioY) {
                    classToUse = "ScaleFullHeight";
                }
                else {
                    classToUse = "ScaleFullWidth";
                }
            }
        }
        element.addClass(classToUse);
        return ready;
    }
    CS.AutoSetScaleClass = AutoSetScaleClass;
    function AddSportEventIdToUrl(url) {
        var sportEventIdPart = "";
        if (url.lastIndexOf("/") + 1 == url.length) {
            url = url.substring(0, url.length - 1);
        }
        let existingSportEventId = parseInt(url.substring(url.lastIndexOf("/") + 1, url.length), 10);
        if (!isNaN(existingSportEventId)) {
            return url;
        }
        else if (CSParameters != null && CSParameters.SportEventId != null) {
            sportEventIdPart = "/" + CSParameters.SportEventId;
            //Ici, je m'assure de fermer le url
            url = "/" + url + "/";
            //Par contre, s'il était déjà fermé, je corrige le probleme
            url = url.replaceAll("//", "/");
            var lastIndex = url.lastIndexOf("/");
            var beforeLastIndex = url.lastIndexOf("/", lastIndex - 1);
            var sportEventId = url.slice(beforeLastIndex, url.length);
            sportEventId = sportEventId.replaceAll("/", "");
            if (isNaN(parseInt(sportEventId, 10))) {
                url += CSParameters.SportEventId;
            }
            else {
                url = url.replace("/" + sportEventId + "/", sportEventIdPart);
            }
            return url;
        }
        return url;
    }
    CS.AddSportEventIdToUrl = AddSportEventIdToUrl;
    //export function GetFormPostFile(url, data, callback?) {
    //    // Include CSRF token if required
    //    var token = $('input[name="__RequestVerificationToken"]').val();
    //    if (token) {
    //        data["__RequestVerificationToken"] = token;
    //    }
    //    CompuSport.Ajax.Post(url, data, function (response, xhr) {
    //        // Assuming the response is a file, create a link and trigger download
    //        var filename = ""; // You might want to obtain this from the response headers or another source
    //        var disposition = xhr.getResponseHeader('Content-Disposition');
    //        if (disposition) {
    //            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    //            var matches = filenameRegex.exec(disposition);
    //            if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
    //        }
    //        var blob = new Blob([response], { type: xhr.getResponseHeader('Content-Type') });
    //        var downloadUrl = URL.createObjectURL(blob);
    //        var a = document.createElement("a");
    //        a.href = downloadUrl;
    //        a.download = filename;
    //        document.body.appendChild(a);
    //        a.click();
    //        if (callback) {
    //            callback();
    //        }
    //        // Cleanup
    //        setTimeout(function () {
    //            URL.revokeObjectURL(downloadUrl);
    //            $(a).remove();
    //        }, 100); // Timeout for revoking the ObjectURL
    //    }, function (xhr, status, error) {
    //        console.error("Error during AJAX request:", error);
    //    });
    //}
    function SetCalendarRegionalSettings() {
        /* Francais */
        $.datepicker.regional["fr"] = {
            clearText: "Effacer",
            clearStatus: "",
            closeText: "Fermer",
            closeStatus: "Fermer sans modifier",
            prevText: "&lt;Préc",
            prevStatus: "Voir le mois précédent",
            nextText: "Suiv&gt;",
            nextStatus: "Voir le mois suivant",
            currentText: "Courant",
            currentStatus: "Voir le mois courant",
            monthNames: [
                "Janvier",
                "Février",
                "Mars",
                "Avril",
                "Mai",
                "Juin",
                "Juillet",
                "Août",
                "Septembre",
                "Octobre",
                "Novembre",
                "Décembre",
            ],
            monthNamesShort: [
                "Jan",
                "Fév",
                "Mar",
                "Avr",
                "Mai",
                "Jun",
                "Jul",
                "Aoû",
                "Sep",
                "Oct",
                "Nov",
                "Déc",
            ],
            monthStatus: "Voir un autre mois",
            yearStatus: "Voir un autre année",
            weekHeader: "Sm",
            weekStatus: "",
            dayNames: [
                "Dimanche",
                "Lundi",
                "Mardi",
                "Mercredi",
                "Jeudi",
                "Vendredi",
                "Samedi",
            ],
            dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
            dayNamesMin: ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
            dayStatus: "Utiliser DD comme premier jour de la semaine",
            dateStatus: "Choisir le DD, MM d",
            firstDay: 0,
            initStatus: "Choisir la date",
            isRTL: false,
        };
        /* Finnish initialisation for the jQuery UI date picker plugin. */
        /* Written by Harri Kilpi (harrikilpio@gmail.com). */
        $.datepicker.regional["fi"] = {
            closeText: "Sulje",
            prevText: "&laquo;Edellinen",
            nextText: "Seuraava&raquo;",
            currentText: "T&auml;n&auml;&auml;n",
            monthNames: [
                "Tammikuu",
                "Helmikuu",
                "Maaliskuu",
                "Huhtikuu",
                "Toukokuu",
                "Kes&auml;kuu",
                "Hein&auml;kuu",
                "Elokuu",
                "Syyskuu",
                "Lokakuu",
                "Marraskuu",
                "Joulukuu",
            ],
            monthNamesShort: [
                "Tammi",
                "Helmi",
                "Maalis",
                "Huhti",
                "Touko",
                "Kes&auml;",
                "Hein&auml;",
                "Elo",
                "Syys",
                "Loka",
                "Marras",
                "Joulu",
            ],
            dayNamesShort: ["Su", "Ma", "Ti", "Ke", "To", "Pe", "Su"],
            dayNames: [
                "Sunnuntai",
                "Maanantai",
                "Tiistai",
                "Keskiviikko",
                "Torstai",
                "Perjantai",
                "Lauantai",
            ],
            dayNamesMin: ["Su", "Ma", "Ti", "Ke", "To", "Pe", "La"],
            weekHeader: "Vk",
            dateFormat: "dd.mm.yy",
            firstDay: 1,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: "",
        };
        /* Espagnol */
        $.datepicker.regional['es'] = {
            dateFormat: 'yy-mm-dd',
            monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
            monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
            dayNames: ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'],
            dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
            dayNamesMin: ['Do', 'Lu', 'Ma', 'Mc', 'Ju', 'Vi', 'Sa'],
            clearText: 'Borrar', clearStatus: '',
            closeText: 'Cerrar', closeStatus: 'Cerrar sin modificar',
            prevText: '&lt;Anterior', prevStatus: 'Ver el mes anterior',
            nextText: 'Siguiente&gt;', nextStatus: 'Ver el siguiente mes',
            currentText: 'Actual', currentStatus: 'Ver el mes actual'
        };
        if (!(typeof CSParameters === "undefined") && CSParameters != null && CSParameters.Language.toLowerCase() == "fr") {
            $.datepicker.setDefaults($.datepicker.regional["fr"]);
            $.datepicker.setDefaults({ dateFormat: "yy-mm-dd" });
        }
        else if (!(typeof CSParameters === "undefined") && CSParameters != null && CSParameters.Language == "fi") {
            $.datepicker.setDefaults($.datepicker.regional["fi"]);
            $.datepicker.setDefaults({ dateFormat: "dd.mm.yy" });
        }
        else if (!(typeof CSParameters === "undefined") && CSParameters != null && CSParameters.Language == "es") {
            $.datepicker.setDefaults($.datepicker.regional["es"]);
            $.datepicker.setDefaults({ dateFormat: "yy-mm-dd" });
        }
        else {
            $.datepicker.setDefaults($.datepicker.regional[""]);
        }
    }
    CS.SetCalendarRegionalSettings = SetCalendarRegionalSettings;
    function generateUUID() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
            const r = (Math.random() * 16) | 0;
            const v = c === "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }
    CS.generateUUID = generateUUID;
})(CS || (CS = {}));

//# sourceMappingURL=CS.js.map
